const overview = {
	bttn_create: "Tuxis daDup erstellen",
	card: {
		body: {
			datastore_name: "Datastore-Name",
			description: "Beschreibung",
			free_version: "Kostenlose Version",
			hostname: "daDup Host",
			in_use: "In Verwendung",
			location: "Serverstandort",
			name: "Anzeigename",
			new: "Kürzlich erstellt",
			username: "Benutzername",
		},
		footer: {
			bttn: "Details anzeigen",
		},
	},
	empty: "Sie haben noch kein Tuxis daDup-Konto",
	title: "Tuxis daDup Übersicht",
};

const cancelDialog = {
	description:
		"Wenn Sie diesen Dienst kündigen, wird er beendet und alle Daten werden dauerhaft gelöscht. Zur Bestätigung wiederholen Sie bitte unten den Namen des daDup <strong>{{username}}</strong>.",
	label: "Benutzername",
	placeholder: "Der Benutzername, mit dem Sie sich bei daDup anmelden.",
	submit_button: "daDup-Konto löschen",

	success_message: "daDup erfolgreich gekündigt!",
	title: "daDup-Konto löschen",
};

const page = {
	current_usage: {
		in_use: "Derzeit in Verwendung",
		title: "Aktuelle Nutzung",
	},
	delete_button: "daDup kündigen",

	info_tile: {
		description: "Beschreibung",
		host: "daDup Host",
		location: "Serverstandort",
		name: "Anzeigename",
		relation_title: "Verknüpfte Relation",
		title: "daDup-Informationen",
		username: "Benutzername",
	},
	password_tile: {
		credentials_saved_button: "Ich habe die Daten gespeichert",
		description:
			"Die Anmeldedaten werden <strong>30 Tage</strong> im Passwort-Tresor gespeichert. Sichern Sie diese Daten in Ihrem eigenen Passwortmanager.",
		description_completed:
			"Sie haben die Anmeldedaten aus dem Passwort-Tresor in Ihrem Passwortmanager gespeichert.",
		password_vault_button: "Zum Passwort-Tresor",
		request_credentials: "Zugangsdaten verloren? Beantragen Sie neue Zugangsdaten.",
		title: "daDup-Anmeldedaten",
	},
	title: "Tuxis daDup-Kontoinformationen",
};
const bucket = {
	add_button: "Bucket hinzufügen",
	create_dialog: {
		description: "Erstellt einen Bucket in Ihrem daDup-Konto; wählen Sie einen passenden Namen.",
		label: "Bucket-Name",
		placeholder: "z. B. bucket01",
		success: "Bucket erfolgreich angefordert! Dies kann einige Minuten dauern.",
		title: "Bucket hinzufügen",
	},
	delete_dialog: {
		description:
			"Wenn Sie den Bucket <strong>{{name}}</strong> löschen, werden alle Daten dauerhaft entfernt und diese Aktion kann nicht rückgängig gemacht werden. Sind Sie sicher?",
		label: "Bucket-Name",
		placeholder: "Der Name des Buckets",
		submit: "Bucket löschen",
		success: "Bucket erfolgreich gelöscht!",
		title: "Bucket „{{name}}“ löschen",
	},
	table: {
		title: "Buckets",
	},
};

const manage = {
	bucket: bucket,
	cancel_dialog: cancelDialog,
	mange: "daDup verwalten",
	overview: overview,
	page: page,
};

export default manage;
